import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSupportWidgetContextV2 } from "../context/supportWidgetContext";
import { getLocalStorage, setLocalStorage } from "../utils/storageUtils";

interface RecentLocationWrapperProps {
  children: React.ReactNode;
}

const RecentLocationWrapper = ({
  children,
}: RecentLocationWrapperProps): JSX.Element => {
  const location = useLocation();
  const { collapseWidget } = useSupportWidgetContextV2();

  useEffect(() => {
    setLocalStorage({
      ...getLocalStorage(),
      location: location.pathname,
    });
    if (
      location.pathname !== "/form" &&
      !location.pathname.startsWith("/posts/") &&
      !location.pathname.startsWith("/news/")
    ) {
      collapseWidget();
    }
  }, [location.pathname, collapseWidget]);

  return <>{children}</>;
};

export default RecentLocationWrapper;
